import Layout from '@src/Layout'
import { locationReplace } from '@/utils/helper'
import { bmSsrUrl } from '@/conf/url.config';
import { inZLJ, inPlum } from '@/utils/env'

// 往组件里注入params和query， 类似react-router
function createPropsFn(defaultQuery = {}) {
  return function(route) {
    return {
      query: Object.assign({}, defaultQuery, route.query)
    }
  }
}

export default {
  path: '/helpsale',
  component: Layout,
  children: [
    {
      path: 'search',
      name: 'helpsale-search',
      props: createPropsFn({ cateParentId: 101 }),
      meta: {
        title: '搜索',
        pageId: inZLJ ? 'J8767' : 'F8192', // 将作为页面埋点的 actionType
        level: 3
      },
      component: () => import(/* webpackChunkName: "helpsale-search" */ 'app/help-sale/search/entry.vue')
    },
    {
      path: 'model-select',
      name: 'model-select',
      props: createPropsFn(),
      meta: {
        title: inPlum ? '品类选择' : '机型选择',
        pageId: inZLJ ? 'A7650' : 'Q8688', // 将作为页面埋点的 actionType
        level: 3
      },
      component: () => import(/* webpackChunkName: "model-select" */ 'app/help-sale/model-select/entry.vue')
    },
    {
      path: 'old-clothes-recycle',
      name: 'old-clothes-recycle',
      props: createPropsFn(),
      meta: {
        title: '旧衣回收',
        pageId: 'F9352', // 将作为页面埋点的 actionType
        needLogin: true,
        level: 2
      },
      component: () => import(/* webpackChunkName: "old-clothes-recycle" */ 'app/help-sale/old-clothes-recycle/index.vue')
    },

    {
      path: 'blind-box-recycle',
      name: 'blind-box-recycle',
      props: createPropsFn(),
      meta: {
        title: '盲盒回收',
        pageId: 'S5947', // 将作为页面埋点的 actionType
        needLogin: true,
        level: 2
      },
      component: () => import(/* webpackChunkName: "blind-box-recycle" */ 'app/help-sale/blind-box-recycle/index.vue')
    },
    {
      path: 'blind-box-recycle-search',
      name: 'blind-box-recycle-search',
      props: createPropsFn(),
      meta: {
        title: '盲盒搜索',
        level: 3,
        pageId: 'G7727' // 将作为页面埋点的 actionType
      },
      component: () => import(/* webpackChunkName: "blind-box-recycle-search" */ 'app/help-sale/blind-box-recycle/search.vue')
    },
    /**
     * 回收首页 方案H, 全量ssr新首页
     */
    {
      path: 'correlate-Hplan-index', // 回收首页 方案H
      name: 'correlate-Hplan-index',
      meta: {
        title: '转转回收',
        pageId: 'Q1075', // 将作为页面埋点的 actionType
        level: 2
      },
      beforeEnter: () => {
        // 重定向的链接，原链接拼了cateId会走首页cateId的逻辑，不合理
        locationReplace(bmSsrUrl.home, { cateId: '' })
      }
    },
    {
      path: 'correlate-Bplan-index', // 回收首页 方案B-笔记本/智能数码（原数码下单页，后与h2合并后）
      name: 'correlate-Bplan-index',
      props: createPropsFn(),
      meta: {
        title: '估价结果',
        needLogin: true,
        pageId: 'T1082', // 将作为页面埋点的 actionType
        level: 5
      },
      component: () =>
        import(/* webpackChunkName: "correlate-H2" */ 'app/help-sale/correlate-H2/second-entry.vue')
    },
    {
      path: 'correlate-Hplan-second', // 回收首页跳转第二页 方案H (20220324 手机数码合并)
      name: 'correlate-Hplan-second',
      props: createPropsFn(),
      meta: {
        title: '估价结果',
        needLogin: true,
        pageId: 'T1082', // 将作为页面埋点的 actionType
        level: 5
      },
      component: () =>
        import(/* webpackChunkName: "correlate-H2" */ 'app/help-sale/correlate-H2/second-entry.vue')
    },
    {
      path: 'price-expectation', // 到手价参考页面
      name: 'price-expectation',
      props: createPropsFn(),
      meta: {
        title: '',
        needLogin: true,
        pageId: 'V3518', // 将作为页面埋点的 actionType
        level: 5
      },
      component: () =>
        import(/* webpackChunkName: "price-expectation" */ 'app/help-sale/price-expectation/index.vue')
    },
    {
      path: 'my-privilege',
      name: 'my-privilege',
      meta: {
        title: '我的回收特权',
        pageId: 'G7393', // 将作为页面埋点的 actionType
        level: 3,
        needLogin: true
      },
      component: () => import(/* webpackChunkName: "my-privilege" */ 'app/help-sale/myPrivilege')
    },
    {
      path: 'evaluate-Bplan', // 估价页面-B方案
      name: 'helpsale-evaluate-Bplan',
      meta: {
        title: '估价信息',
        pageId: inZLJ ? 'N7704' : 'A5341', // 将作为页面埋点的 actionType
        level: 4
      },
      component: () =>
        import(/* webpackChunkName: "helpsale-evaluate-Bplan" */ 'app/help-sale/evaluate/entry')
    },
    {
      path: 'evaluate-Dplan', // 估价页面-D方案
      name: 'helpsale-evaluate-Dplan',
      meta: {
        title: '估价信息',
        pageId: inZLJ ? 'N7704' : 'A5341', // 将作为页面埋点的 actionType
        level: 4
      },
      component: () => import(/* webpackChunkName: "helpsale-evaluate-Bplan" */ 'app/help-sale/evaluate/entry')
    },
    {
      path: 'evaluate', // 估价页面-A方案
      name: 'helpsale-evaluate',
      meta: {
        title: '估价信息',
        pageId: inZLJ ? 'N7704' : 'A5341', // 将作为页面埋点的 actionType
        level: 4
      },
      component: () =>
        import(/* webpackChunkName: "helpsale-evaluate" */ 'app/help-sale/evaluate/entry')
    },
    {
      path: 'description', // 功能详细描述
      name: 'helpsale-description',
      component: () =>
        import(/* webpackChunkName: "helpsale-description" */ 'app/help-sale/description')
    },
    {
      path: 'tutorial', // 估价参数查询教程 (页面提供给客户端，估价页使用组件)
      name: 'helpsale-tutorial',
      component: () => import(/* webpackChunkName: "helpsale-tutorial" */ 'app/help-sale/tutorial')
    },
    {
      path: 'home-recycling', // 上门回收落地页
      name: 'helpsale-home-recycling',
      meta: { title: '上门回收' },
      component: () => import(/* webpackChunkName: "helpsale-recycling" */ 'app/help-sale/home-recycling')
    },
    {
      path: 'recycle-car-order', // 转转回收车，一键下多品类多单
      name: 'recycle-car-order',
      meta: {
        title: '提交订单',
        needLogin: true,
        pageId: 'B2570', // 将作为页面埋点的 actionType
        level: 2
      },
      component: () => import(/* webpackChunkName: "recycle-car-order" */ 'app/help-sale/recycle-car-order/index')
    },
    {
      path: 'recycle-car', // 转转回收车，一键下多品类多单
      name: 'recycle-car',
      meta: {
        title: '待卖清单',
        needLogin: true,
        pageId: 'M3298', // 将作为页面埋点的 actionType
        level: 2
      },
      component: () => import(/* webpackChunkName: "recycle-car" */ 'app/help-sale/recycle-car/index')
    },
    {
      path: 'van-recycle-car', // 转转回收车，一键下多品类多单
      name: 'van-recycle-car',
      meta: {
        pageId: 'P7574', // 将作为页面埋点的 actionType
        level: 2
      },
      component: () => import(/* webpackChunkName: "van-recycle-car" */ 'app/help-sale/van-recycle-car/index')
    },
    {
      path: 'select-cate', // 身价估算器 - 选择品类
      name: 'select-cate',
      meta: {
        title: '',
        needLogin: true,
        pageId: 'L5542', // 将作为页面埋点的 actionType
        level: 2
      },
      component: () => import(/* webpackChunkName: "select-cate" */ 'app/help-sale/worth-evaluate/select-cate.vue')
    },
    {
      path: 'evaluate-car-share', // 身价估算器 - 分享海报
      name: 'evaluate-car-share',
      meta: { title: '身价估算器海报' },
      component: () => import(/* webpackChunkName: "evaluate-car-share" */ 'app/help-sale/worth-evaluate/share-poster.vue')
    },
    {
      path: 'evaluate-car', // 身价估算器 - 回收车
      name: 'evaluate-car',
      meta: {
        title: '身价估算器',
        needLogin: true,
        pageId: 'U3983', // 将作为页面埋点的 actionType
        level: 2
      },
      component: () => import(/* webpackChunkName: "evaluate-car" */ 'app/help-sale/worth-evaluate/evaluate-car.vue')
    },
    {
      path: 'coupon-centre', // 领券中心
      name: 'coupon-centre',
      meta: {
        title: '领券中心',
        pageId: 'G3053', // 将作为页面埋点的 actionType
        level: 2
      },
      component: () => import(/* webpackChunkName: "coupon-centre" */ 'app/help-sale/coupon-centre/entry.vue')
    },
    {
      path: 'merge-order', // 合并提单页面
      name: 'merge-order',
      meta: {
        title: '提交订单',
        needLogin: true,
        pageId: 'L8746', // 将作为页面埋点的 actionType
        level: 2
      },
      component: () => import(/* webpackChunkName: "merge-order" */ 'app/help-sale/merge-order/index.vue')
    },
    // ================= 一键上门相关路由 =================
    {
      path: 'one-click-d2d', // 一键上门主页面
      name: 'one-click-d2d',
      meta: {
        title: '一键上门',
        needLogin: false, // 首页允许未登录访问，加购等操作再拦截
        pageId: 'N6434',
        level: 2
      },
      component: () => import(/* webpackChunkName: "one-click-d2d" */ 'app/help-sale/one-click-d2d/index.vue')
    },
    {
      path: 'one-click-d2d/search', // 一键上门搜索页
      name: 'one-click-d2d-search',
      meta: {
        title: '搜索商品',
        needLogin: false,
        pageId: 'I9077',
        level: 3
      },
      component: () => import(/* webpackChunkName: "one-click-d2d-search" */ 'app/help-sale/one-click-d2d/search.vue')
    },
    {
      path: 'one-click-d2d/order', // 一键上门下单页
      name: 'one-click-d2d-order',
      meta: {
        title: '确认订单',
        needLogin: true, // 下单页必须登录
        pageId: 'W4870',
        level: 3
      },
      component: () => import(/* webpackChunkName: "one-click-d2d-order" */ 'app/help-sale/one-click-d2d/order.vue')
    },
    // ================= 一键上门 V2 路由 =================
    {
      path: 'one-click-d2d-v2', // 新版一键上门主页面
      name: 'one-click-d2d-v2',
      meta: {
        title: '上门回收',
        needLogin: true,
        pageId: 'E3641',
        level: 2
      },
      component: () => import(/* webpackChunkName: "one-click-d2d-v2" */ 'app/help-sale/one-click-d2d/v2/index.vue')
    },
    {
      path: 'one-click-d2d-v2/selected-items', // 新版已选物品页面
      name: 'one-click-d2d-v2-selected-items',
      meta: {
        title: '已选物品',
        needLogin: true,
        pageId: 'M5760',
        level: 3
      },
      component: () => import(/* webpackChunkName: "one-click-d2d-v2-selected" */ 'app/help-sale/one-click-d2d/v2/selected-items.vue')
    }
  ]
}
